import axiosAPI from "@/components/request/request";

export default {
    //删除指定用户
    deleteUserById(id) {
        return axiosAPI.post(`/admin/delete/${id}`)
    },

    //用户停用及资源推送
    stopUserAndPush(fromUserId, toUserIds) {
        return axiosAPI.post('/admin/transfer', {
                fromUserId: fromUserId,
                toUserIds: toUserIds
            })
    },
    
    getLoginUserInfo() {
        return axiosAPI.get('/admin/info')
    },

    //获取指定用户信息
    getUserInfo(id) {
        return axiosAPI.get(`/app/contact/detail/${id}`)
    }
}